import { produce } from 'immer';
import { combineReducers } from 'redux';
import * as types from './types';
import _ from 'lodash';


const initialListState: types.ListState = {
    local: false,
    loading: false,
    error: false,
    request: undefined,
    response: undefined,
    hidden: false, // show hidden fields
    query: '',
}

const listReducer = (
    state = initialListState,
    action: types.ListActions
) => {
    return produce(state, draft => {
        if (action.type === types.LIST_START_QUERY) {
            draft.local = action.local;
            draft.loading = true;
            draft.request = action.request;
            draft.error = false;

        } else if (action.type === types.LIST_RESPONSE) {
            draft.response = action.response;
            draft.loading = false;
            draft.error = false;

        } else if (action.type === types.LIST_ERROR) {
            draft.error = true;
            draft.loading = false;

        } else if (action.type === types.LIST_RESET) {
            draft.local = initialListState.local;
            draft.loading = initialListState.loading;
            draft.error = initialListState.error;
            draft.request = initialListState.request;
            draft.response = initialListState.response;
            draft.hidden = initialListState.hidden;
            draft.query = initialListState.query;
            delete draft.name;

        } else if (action.type === types.LIST_RESET_CONFIG) {
            draft.loading = initialListState.loading;
            draft.error = initialListState.error;
            draft.response = initialListState.response;
            draft.query = initialListState.query;

        } else if (action.type === types.LIST_SET_HIDDEN) {
            draft.hidden = action.hidden;

        } else if (action.type === types.LIST_SET_QUERY) {
            draft.query = action.query;

        } else if (action.type === types.LIST_SET_ATTRS) {
            draft.request!.attributes = action.attrs;

        } else if (action.type === types.LIST_SET_FILTER) {
            draft.request!.filter = draft.query;

        }
    });
};

const reducer = combineReducers({
    list: listReducer,
});

export default reducer;
